import { render, staticRenderFns } from "./turnstiles.vue?vue&type=template&id=c49c71f6"
import script from "./turnstiles.vue?vue&type=script&lang=js"
export * from "./turnstiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports